/** User-facing copy for Efficacy swab outcomes (internal code may still say "residual"). */

export const SWAB_PAIR_EXPLAINER =
  'Each swab is taken before and after UVC. Cleared = no growth after disinfection. Post-UVC positive = growth still detected on the after swab.';

export const EFFICACY_TERMS = {
  postUvcPositive: {
    short: 'Post-UVC positive',
    kpiLabel: 'POST-UVC POSITIVES',
    kpiHelp: 'Swab sites where lab culture was still positive after UVC disinfection this month.',
    kpiSubtextZero: 'none this month',
    kpiSubtextResolved: 'all followed up',
    kpiSubtextOpen: 'follow-up in progress',
    timelineLegend: 'Post-UVC positive (followed up)',
    timelineBannerLast: (date, room) =>
      `Last post-UVC positive: ${date} · ${room} · cleared on next cycle`,
    timelineBannerNone: 'No post-UVC positives on record before this streak.',
    sectionTitle: 'Follow-up log — post-UVC positives',
    sectionSubtitle:
      'Where growth was still detected after UVC — what was found and how it was resolved.',
    pathogenDetail: (n) => `${n} post-UVC positive${n === 1 ? '' : 's'} · reviewed`,
    emptyState: 'No post-UVC positives in the current swab data.',
    resultZero: 'Result: 0 post-UVC positives in the paired swab window on file',
    resultSome:
      'Result: post-UVC positive sites listed above — track repeats and protocol adjustments',
    cardBody: 'Post-UVC growth still detected on one or more swab sites.',
    reportsStatus: 'Post-UVC positive',
  },
  cleared: {
    short: 'Cleared post-UVC',
    timelineLegend: 'Cleared post-UVC',
  },
};

/** KPI subtext for post-UVC positive count. */
export function postUvcPositiveKpiSubtext(count, allResolved) {
  if (count === 0) return EFFICACY_TERMS.postUvcPositive.kpiSubtextZero;
  return allResolved
    ? EFFICACY_TERMS.postUvcPositive.kpiSubtextResolved
    : EFFICACY_TERMS.postUvcPositive.kpiSubtextOpen;
}
